module.exports = __webpack_public_path__ + "static/media/ic_navbar_logo.a2692326.svg";